/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFormateurPrestationsContratGridDto } from './FcbFormateurPrestationsContratGridDto';
import {
    FcbFormateurPrestationsContratGridDtoFromJSON,
    FcbFormateurPrestationsContratGridDtoFromJSONTyped,
    FcbFormateurPrestationsContratGridDtoToJSON,
} from './FcbFormateurPrestationsContratGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbFormateurPrestationsContratGridDtoPaginatedResults
 */
export interface FcbFormateurPrestationsContratGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurPrestationsContratGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbFormateurPrestationsContratGridDto>}
     * @memberof FcbFormateurPrestationsContratGridDtoPaginatedResults
     */
    results?: Array<FcbFormateurPrestationsContratGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbFormateurPrestationsContratGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbFormateurPrestationsContratGridDtoPaginatedResults interface.
 */
export function instanceOfFcbFormateurPrestationsContratGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurPrestationsContratGridDtoPaginatedResultsFromJSON(json: any): FcbFormateurPrestationsContratGridDtoPaginatedResults {
    return FcbFormateurPrestationsContratGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbFormateurPrestationsContratGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurPrestationsContratGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbFormateurPrestationsContratGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbFormateurPrestationsContratGridDtoPaginatedResultsToJSON(value?: FcbFormateurPrestationsContratGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbFormateurPrestationsContratGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

